
import {
  defineComponent, watch, reactive, ref, computed,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Toast } from '@/utils';
import { useStore } from 'vuex';
import Cookie from 'js-cookie';
import { logout as reqLogout } from '@/request/login';
import { updateAfterSalePassword } from '@/request/view/afterSale';
import { saveOrUpdateUser } from '@/request/view/repair';
import websocket from '@/utils/base/socket';
import breadCrumb from './breadcrumb.vue';
import noticeBell from '@/layout/components/noticeBell.vue';

export default defineComponent({
  props: {
    collapsed: Boolean,
  },
  components: { breadCrumb, noticeBell },
  setup(props, context) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const user = store.state.user.user;

    const validatePassword = (password) => {
      // 正则表达式匹配八位长度且包含账号密码的字符串
      const regex = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8,20}$/;
      // 使用test方法检查密码是否符合条件
      return regex.test(password);
    }

    const validatePass = (rule, value) => {
      if (validatePassword(value)) {
        return Promise.resolve();
      }
      return Promise.reject("请输入8-20个字符(字母、数字或标点符号至少包含两种)");
    };

    // 已有的路由数组
    const hasChildRoute = {};
    const hasChild = ref(undefined);
    router.getRoutes().forEach((item) => {
      if (item.children && item.children.length > 0 && item.path !== '/dashboard') {
        item.children.forEach((subItem) => {
          hasChildRoute[subItem.path] = item.meta.title;
        });
      }
    });
    // 面包屑的文字
    const show = reactive({
      title: '首页',
    });

    const formRef = ref();
    const formData = reactive({
      oldPassword: '',
      newPassword: '',
      visible: false,
    });

    const forceStatus = ref(false);

    console.log(user.password);

    if (!validatePassword(user.password)) {
      formData.visible = true;
      forceStatus.value = true;
    }

    const rules = {
      newPassword: [{ required: true, trigger: "blur", validator: validatePass, }],
      // oldPassword: [{ required: true, message: "请输入旧密码", trigger: "blur", type: "string", }],
    };
    // 
    const changePasswordModal = () => {
      formData.visible = true;
    };
    const cancelChangePawword = () => {
      formData.visible = false;
      formData.newPassword = '';
      // formData.oldPassword = '';
    };

    const resetPassword = () => {
      user.password = formData.newPassword;
      localStorage.setItem('qc_userInfo', JSON.stringify(user));
    };

    const changePassword = () => {
      formRef.value.validateFields().then(() => {
        saveOrUpdateUser({
          id: store.state.user.user.id,
          password: formData.newPassword
        }).then((res: any) => {
          if (res.code === 200) {
            resetPassword()
            cancelChangePawword();
            Toast('success', res.message, 3);
          } else {
            Toast('waring', res.message, 3);
          }
        })
        // const params = new URLSearchParams();
        // params.append('id', store.state.user.user.id);
        // params.append('newPassword', formData.newPassword);
        // params.append('oldPassword', formData.oldPassword);
        // updateAfterSalePassword(params).then((res: any) => {
        //   if (res.code === 200) {
        //     cancelChangePawword();
        //     Toast('success', res.message, 3);
        //   } else {
        //     Toast('waring', res.message, 3);
        //   }
        // })
      })
    };
    // 登出
    const logout = () => {
      websocket.Close();
      localStorage.setItem("logout", 'true');
      store.commit("SET_USER_INFO", {});
      const long = window.history.length - 1;
      router.go(-long);
      window.location.reload();
    };

    watch(() => route.path, () => {
      if (hasChildRoute[route.path] !== undefined) {
        hasChild.value = hasChildRoute[route.path];
      } else {
        hasChild.value = undefined;
      }
      show.title = String(route.meta.title);
    });
    const username = computed(() => store.state.user.user.nickName);
    return {
      show,
      user,
      formRef,
      formData,
      props,
      hasChild,
      logout,
      username,
      rules,
      forceStatus,
      changePasswordModal,
      changePassword,
      cancelChangePawword
    };
  },
});
